/* eslint-disable react/no-unescaped-entities */
export const MinimumRequirementsInstructions = () => {
  return (
    <div className='instructions-container'>
      <p className='instructions-content-text'>
        As a minimum, the following pieces of consumer information are required
        in your consumer file in order to submit a request:
      </p>
      <div className='instructions-item'>
        <div className='instructions-title'>Consumer Address Minimums</div>
        <div className='instructions-content'>
          <p className='instructions-content-text'>
            Full address (House number, street name, ZIP Code). The following
            header combinations are valid; only one combination should be used
            for your file:
          </p>
          <ul className='instructions-content-list'>
            <li>
              <p>Addr1_House_No, Addr1_Street, Addr1_ZIP5</p>
            </li>
            <li>
              <p>Addr1_House_No, Addr1_Street, Addr1_ZIP9</p>
            </li>
            <li>
              <p>Addr1_House_No, Addr1_Street, Addr1_St_ZIP5</p>
            </li>
            <li>
              <p>Addr1_House_No, Addr1_Street, Addr1_City_St_ZIP5</p>
            </li>
            <li>
              <p>Addr1_Line1, Addr1_ZIP5</p>
            </li>
            <li>
              <p>Addr1_Line1, Addr1_ZIP9</p>
            </li>
            <li>
              <p>Addr1_Line1, Addr1_ZIP5_No_Zero_Fill</p>
            </li>
            <li>
              <p>Addr1_Line1, Addr1_St_ZIP5</p>
            </li>
            <li>
              <p>Addr1_Line1, Addr1_City_St_ZIP5</p>
            </li>
            <li>
              <p>Addr1_Full</p>
            </li>
            <li>
              <p>
                The rules listed above are applicable for Addr2* and Addr3* if
                present.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className='instructions-item'>
        <div className='instructions-title'>Consumer Name Minimums</div>
        <div className='instructions-content'>
          <p className='instructions-content-text'>
            Full name (first and last). The following header combinations are
            valid; only one combination should be used for your file:
          </p>
          <ul className='instructions-content-list'>
            <li>
              <p>First_Name, Last_Name</p>
            </li>
            <li>
              <p>First_Middle_Name, Last_Name</p>
            </li>
            <li>
              <p>First_Middle_Name, Last_Name_Gen_Code</p>
            </li>
            <li>
              <p>First_Name, Last_Name_Gen_Code</p>
            </li>
            <li>
              <p>Full_Name_FML</p>
            </li>
            <li>
              <p>Full_Name_LFM</p>
            </li>
            <li>
              <p>Full_Name_FL</p>
            </li>
            <li>
              <p>Full_Name_LF</p>
            </li>
          </ul>
        </div>
      </div>
      <div className='instructions-item'>
        <div className='instructions-title'>Consumer Address Combinations</div>
        <div className='instructions-content'>
          <p className='instructions-content-text'>
            If you choose to use more than the minimum address header fields,
            ensure that you stay within these guidelines:
          </p>
          <ul className='instructions-content-list'>
            <li>
              <p>
                If Addr1_ZIP5 is present, then Addr1_ZIP9 or
                Addr1_ZIP5_No_Zero_Fill shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_ZIP9 is present, then Addr1_ZIP5 or
                Addr1_ZIP5_No_Zero_Fill shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_ZIP5_No_Zero_Fill is present, then Addr1_ZIP5 or
                Addr1_ZIP9 shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_City_St is present, then Addr1_City or Addr1_St or
                Addr1_St_ZIP5 or Addr1_City_St_ZIP5 shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_St_ZIP5 is present, then Addr1_St or Addr1_ZIP5 or
                Addr1_City_St or Addr1_City_St_ZIP5 or Addr1_ZIP5_No_Zero_Fill
                or Addr1_ZIP9 shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_City_St_ZIP5 is present, then Addr1_City or Addr1_St or
                Addr1_City_St or Addr1_St_ZIP5 or Addr1_ZIP5 or
                Addr1_ZIP5_No_Zero_Fill or Addr1_ZIP9 shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_Line1 is present, then Addr1_House_No or Addr1_Street
                shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_Line2 is present, then Addr1_Apt shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Addr1_Full is present, then Addr1_Line1 or Addr1_House_No or
                Addr1_Street or Addr1_City or Addr1_St or Addr1_ZIP5 or
                Addr1_ZIP5_No_Zero_Fill or Addr1_ZIP9 shouldn't be present.{' '}
              </p>
            </li>
            <li>
              <p>
                The rules listed above are applicable for Addr2* and Addr3*
                fields if present.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className='instructions-item'>
        <div className='instructions-title'>Consumer Name Combinations</div>
        <div className='instructions-content'>
          <p className='instructions-content-text'>
            If you choose to use more than the minimum name header fields,
            ensure that you stay within these guidelines:
          </p>
          <ul className='instructions-content-list'>
            <li>
              <p>
                If First_Name is present, then First_Middle_Name or
                Full_Name_FML or Full_Name_LMF or Full_Name_FL or Full_Name_LF
                shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Last_Name is present, then Full_Name_FML or Full_Name_LMF or
                Full_Name_FL or Full_Name_LF shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Middle_Name is present, then First_Middle_Name or
                Full_Name_FML or Full_Name_LMF shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If First_Middle_Name is present, then First_Name or Middle_Name
                or Full_Name_FML or Full_Name_LMF or Full_Name_FL or
                Full_Name_LF shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Full_Name_FML or Full_Name_LMF is present, then First_Name or
                First_Middle_Name or Last_Name or Last_Name_Gen_Code or
                Middle_Name shouldn't be present.
              </p>
            </li>
            <li>
              <p>
                If Full_Name_FL or Full_Name_LF is present, then First_Name or
                First_Middle_Name or Last_Name or Last_Name_Gen_Code shouldn't
                be present.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
